import React, { useState } from 'react';
import { Layout } from 'antd';
import { useGlobal } from '../Global/GlobalProvider';
import MainMenu from './MainMenu';

const { Sider, Content } = Layout;

const MainLayout = ({ children }) => {

  const { UserData } = useGlobal();
  const [collapsed, setCollapsed] = useState(window.innerWidth < 768); // Collapse by default on mobile screens

  const toggleSider = () => {
      setCollapsed(!collapsed);
  }
  
  const renderMainSider = () => {

    return (
      <Sider
        width={240}
        hidden={collapsed}
        onCollapse={toggleSider}
        // style={{ position: 'fixed', height: '100vh', overflow: 'auto', paddingTop: 60 }}
        style={{ height: '100vh', overflow: 'auto', }}
        className="site-layout-background"
      >
        <MainMenu/>
      </Sider>
    )
  }

  
  return (
    UserData &&
    <Layout style={{ minHeight: '100vh' }}>
      
      <>
        { renderMainSider() }
        <Layout style={{ marginLeft: !collapsed ? 0 : 0 }}>
      
        <Content style={{ minHeight: 280 }}>  {/* Added marginTop to accommodate the fixed Header */}
            {/* <Outlet/> */}
            { children }
          </Content>
        </Layout>
      </>
    </Layout>
  );
}

export default MainLayout;
